import React from 'react';
import {createBrowserRouter} from "react-router-dom";
import ConnectAdwordsAccount from "./components/agency/link_acocunts/ConnectAdwordsAccount";
import EditBusinessUnitPage from "./components/business_units/global_info/BusinessUnitGlobalInfo";
import AgencyClients from "./components/agency/AgencyClients";
import AgencyTeam from "./components/agency/AgencyTeam";
import {AgencyAlertsConfiguration} from "./components/agency/settings/AgencyAlertsConfiguration";
import ClientConfiguration from "./components/client/ClientConfiguration";
import ClientActivityLog from "./components/client/ClientActivityLog";
import ClientReports from "./components/client/ClientReports";
import ClientAgent from "./components/client/ClientAgent";
import {LoginPage, SignUpPage} from "./components/login/LoginPage";
import AgencyRegister from "./components/agency/AgencyRegister";
import AcceptInvitation from "./components/login/AcceptInvitation";
import {PageNotFound, RouterErrorPage} from "./404";
import BusinessUnitBudgetHistory from "./components/business_units/BusinessUnitBudgetHistory"
import BusinessUnitAlertsConfiguration from "./components/business_units/BusinessUnitAlertsConfiguration";
import {AgencyPrivateRoute, CRMPrivateRoute, PortalPrivateRoute} from "./utils/PrivateRoute";
import {LoginCrm} from "./components/crm/login/LoginCrm";
import LeadsPage from "./components/crm/leads/leads_list/LeadsPage";
import LeadDetail from "./components/crm/leads/lead_detail/LeadDetail";
import ConfigPage from "./components/crm/configuration/ConfigPage";
import ClientCRMUsers from "./components/client/ClientCRMUsers";
import UserConfiguration from "./components/user/UserConfiguration";
import ClientMonitoring from "./components/client/ClientMonitoring";
import ClientControlCentral from "./components/client/ClientControlCentral";
import ClientDefaultRoute from "./components/client/ClientDefaultRoute";
import ClientConnections from "./components/client/ClientConnections";
import {AgencyAdAccountsAndStoresWrapper} from "./components/agency/AgencyAdAccountsAndStoresWrapper";
import AgencySubscription from "./components/agency/AgencySubscription";
import UserAlerts from "./components/user/UserAlerts";
import UserSecurity from "./components/user/UserSecurity";
import UserModuleMarketing from "./components/user/UserModuleMarketing";
import UserModuleManageAccounts from "./components/user/UserModuleManageAccounts";
import AdAccountList from "./components/manage_accounts/AdAccountList";
import {Default} from "./components/Default";
import {DashboardWrapper} from "./components/dashboard/DashboardWrapper";
import {Report} from "./components/reports/Report";
import {AgencyProfile} from "./components/agency/AgencyProfile";
import ClientAppContent from "./components/client/ClientAppContent";
import {FreeTrialEndedPage} from "./components/subscription_not_active/FreeTrialEnded";
import {SubscriptionEndedPage} from "./components/subscription_not_active/SubscriptionEnded";
import UserProfile from "./components/user/UserProfile";
import AgencyConnectionsConfiguration from "./components/agency/AgencyConnectionsConfiguration";
import AgencyFlexIndicatorsConfiguration from "./components/agency/AgencyFlexIndicatorsConfiguration";
import UserClients from "./components/user/UserClients";
import ConnectTiktok from "./components/agency/link_acocunts/ConnectTiktok";
import ConnectLinkedin from "./components/agency/link_acocunts/ConnectLinkedin";
import ConnectGA4Account from "./components/agency/link_acocunts/ConnectGA4Account";
import ConnectShopify from "./components/agency/link_acocunts/ConnectShopify";
import ConnectTiendaNube from "./components/agency/link_acocunts/ConnectTiendaNube";
import SyncConfigurations from "./components/agency/SyncConfigurations";
import AgencyConnectionsExport from "./components/agency/AgencyConnectionsExport";
import App from "./App";
import {DataExplorerPage} from "./components/data_explorer/DataExplorerPage";
import {AgentArea} from "./components/agent/AgentArea";
import {ReportViewer} from "./components/public_reports/ReportViewer";
import {AllReportsPage} from "./components/reports/AllReportsPage";
import {TemplateLibraryPage} from "./components/reports/templates/TemplateLibraryPage";
import {TemplateEditorPage} from "./components/reports/templates/TemplateEditorPage";
import {DashboMCPPage} from "./components/dashbo_mcp/DashboMCPPage";
import {DemoReportPage} from "./components/dashbo_mcp/DemoReportPage";
import {AuthFromMCP} from "./components/login/AuthFromMCP";
import {PortalHome} from "./components/portal/PortalHome";
import {PortalDashboConnect} from "./components/portal/PortalDashboConnect";
import {ClientPortalPreview} from "./components/client/preview/ClientPortalPreview";
import {ClientPortalTabPage} from "./components/client/ClientPortalTabPage";
import {ClientDataExplorer} from "./components/client/ClientDataExplorer";
import {AppLayout} from "./components/layout/AppLayout";
import {ClientOnboardingWizard} from "./components/client_onboarding/ClientOnboardingWizard";
import {DashboardSetupOnboarding} from "./components/dashboard/DashboardSetupOnboarding";

const NewDashboUserPage = () => (
    <section className="section-content dashboard-setup-route">
        <DashboardSetupOnboarding/>
    </section>
);

export const router = createBrowserRouter([
    {
        element: <App/>,
        errorElement: <RouterErrorPage/>,
        children: [
            // Public / Auth routes (no sidebar/topbar)
            {
                path: "/login",
                element: <LoginPage/>
            },
            {
                path: "/free-trial-ended",
                element: <FreeTrialEndedPage/>
            },
            {
                path: "/subscription-ended",
                element: <SubscriptionEndedPage/>
            },
            {
                path: "/signup",
                element: <SignUpPage/>
            },
            {
                path: "/accept-invitation/:hash",
                element: <AcceptInvitation/>
            },
            {
                path: "/auth/from-mcp",
                element: <AuthFromMCP/>
            },
            {
                path: "/r/:uuid",
                element: <ReportViewer/>
            },
            // Portal routes (own layout)
            {
                path: "/portal",
                element: <PortalPrivateRoute><PortalHome/></PortalPrivateRoute>
            },
            {
                path: "/portal/dashbo-connect",
                element: <PortalPrivateRoute><PortalDashboConnect/></PortalPrivateRoute>
            },
            {
                path: "/portal/dashbo-mcp",
                element: <PortalPrivateRoute><PortalDashboConnect/></PortalPrivateRoute>
            },
            // CRM routes (own layout)
            {
                path: "/crm/login",
                element: <LoginCrm/>
            },
            {
                path: "/crm/lead/:id",
                element: <CRMPrivateRoute><LeadDetail/></CRMPrivateRoute>
            },
            {
                path: "/crm/config",
                element: <CRMPrivateRoute><ConfigPage/></CRMPrivateRoute>
            },
            {
                path: "/crm",
                element: <CRMPrivateRoute><LeadsPage/></CRMPrivateRoute>
            },
            // Full-screen onboarding wizard (no sidebar/topbar)
            {
                path: "/agency/clients/new/onboarding",
                element: <AgencyPrivateRoute><ClientOnboardingWizard/></AgencyPrivateRoute>
            },
            // Agency routes with AppLayout (sidebar + topbar)
            {
                element: <AgencyPrivateRoute><AppLayout/></AgencyPrivateRoute>,
                children: [
                    {
                        path: "/",
                        element: <Default/>
                    },
                    {
                        path: "/marketing",
                        element: <DashboardWrapper/>
                    },
                    {
                        path: "/new_dashbo_user",
                        element: <NewDashboUserPage/>
                    },
                    {
                        path: "/data-explorer",
                        element: <DataExplorerPage/>
                    },
                    {
                        path: "/agent/chat/:sessionId?",
                        element: <AgentArea/>
                    },
                    {
                        path: "/insights",
                        element: <Report/>
                    },
                    {
                        path: "/reports/templates/:id",
                        element: <TemplateEditorPage/>
                    },
                    {
                        path: "/reports/templates",
                        element: <TemplateLibraryPage/>
                    },
                    {
                        path: "/reports",
                        element: <AllReportsPage/>
                    },
                    {
                        path: "/dashbo-connect",
                        element: <DashboMCPPage/>
                    },
                    {
                        path: "/dashbo-connect/demo-report",
                        element: <DemoReportPage/>
                    },
                    {
                        path: "/dashbo-mcp",
                        element: <DashboMCPPage/>
                    },
                    {
                        path: "/dashbo-mcp/demo-report",
                        element: <DemoReportPage/>
                    },
                    {
                        path: "/agency/alerts-configuration",
                        element: <AgencyAlertsConfiguration/>
                    },
                    {
                        path: "/agency-register",
                        element: <AgencyRegister/>
                    },
                    {
                        path: "/agency/profile",
                        element: <AgencyProfile/>
                    },
                    {
                        path: "/agency/conections/export",
                        element: <AgencyConnectionsExport/>
                    },
                    {
                        path: "/agency/conections",
                        element: <AgencyConnectionsConfiguration/>
                    },
                    {
                        path: "/agency/flex-indicators",
                        element: <AgencyFlexIndicatorsConfiguration/>
                    },
                    {
                        path: "/agency/subscription",
                        element: <AgencySubscription/>
                    },
                    {
                        path: "/agency/ad-accounts",
                        element: <AgencyAdAccountsAndStoresWrapper/>
                    },
                    {
                        path: "/agency-team",
                        element: <AgencyTeam/>
                    },
                    {
                        path: "/sheets-sync",
                        element: <SyncConfigurations/>
                    },
                    {
                        path: "/connect-adwords-account",
                        element: <ConnectAdwordsAccount/>
                    },
                    {
                        path: "/connect-tiktok",
                        element: <ConnectTiktok/>
                    },
                    {
                        path: "/connect-shopify",
                        element: <ConnectShopify/>
                    },
                    {
                        path: "/connect-tienda-nube",
                        element: <ConnectTiendaNube/>
                    },
                    {
                        path: "/connect-linkedin",
                        element: <ConnectLinkedin/>
                    },
                    {
                        path: "/connect-ga4-account",
                        element: <ConnectGA4Account/>
                    },
                    {
                        path: "/business-unit/:id/budget-history",
                        element: <BusinessUnitBudgetHistory/>
                    },
                    {
                        path: "/business-unit/:id/accounts",
                        element: <EditBusinessUnitPage/>
                    },
                    {
                        path: "/business-unit/:id/alerts-configuration",
                        element: <BusinessUnitAlertsConfiguration/>
                    },
                    {
                        path: "/business-unit/:id/",
                        element: <EditBusinessUnitPage/>
                    },
                    {
                        path: "/client/:id/crm-users",
                        element: <ClientCRMUsers/>
                    },
                    {
                        path: "/client/:id/dashbo-users",
                        element: <ClientConfiguration/>
                    },
                    {
                        path: "/client/:id/business-units",
                        element: <ClientMonitoring/>
                    },
                    {
                        path: "/client/:id/monitoring",
                        element: <ClientMonitoring/>
                    },
                    {
                        path: "/client/:id/conections",
                        element: <ClientConnections/>
                    },
                    {
                        path: "/client/:id/activity-log",
                        element: <ClientActivityLog/>
                    },
                    {
                        path: "/client/:id/reports",
                        element: <ClientReports/>
                    },
                    {
                        path: "/client/:id/agent/:sessionId?",
                        element: <ClientAgent/>
                    },
                    {
                        path: "/client/:id/profile",
                        element: <ClientConfiguration/>
                    },
                    {
                        path: "/client/:id/portal-config",
                        element: <ClientPortalTabPage/>
                    },
                    {
                        path: "/client/:id/configuration",
                        element: <ClientConfiguration/>
                    },
                    {
                        path: "/client/:client_id/app/:app_hash/",
                        element: <ClientAppContent/>
                    },
                    {
                        path: "/client/:id/control-central",
                        element: <ClientControlCentral/>
                    },
                    {
                        path: "/client/:id/data-explorer",
                        element: <ClientDataExplorer/>
                    },
                    {
                        path: "/client/:id/preview",
                        element: <ClientPortalPreview/>
                    },
                    {
                        path: "/client/:id/preview/dashbo-connect",
                        element: <ClientPortalPreview/>
                    },
                    {
                        path: "/client/:id/preview/dashbo-mcp",
                        element: <ClientPortalPreview/>
                    },
                    {
                        path: "/client/:id",
                        element: <ClientDefaultRoute/>
                    },
                    {
                        path: "/clients",
                        element: <UserClients/>
                    },
                    {
                        path: "/agency/clients",
                        element: <AgencyClients/>
                    },
                    {
                        path: "/user-configuration",
                        element: <UserConfiguration/>
                    },
                    {
                        path: "/user/:id/profile",
                        element: <UserProfile/>
                    },
                    {
                        path: "/user/:id/security",
                        element: <UserSecurity/>
                    },
                    {
                        path: "/user/:id/module/marketing",
                        element: <UserModuleMarketing/>
                    },
                    {
                        path: "/user/:id/module/manage-accounts",
                        element: <UserModuleManageAccounts/>
                    },
                    {
                        path: "/user/:id",
                        element: <UserAlerts/>
                    },
                    {
                        path: "/manage-accounts",
                        element: <AdAccountList/>
                    },
                    // CRM routes accessed from agency context
                    {
                        path: "/crm/:clientId/lead/:id",
                        element: <LeadDetail/>
                    },
                    {
                        path: "/crm/:clientId/config",
                        element: <ConfigPage/>
                    },
                    {
                        path: "/crm/:clientId",
                        element: <LeadsPage/>
                    },
                ]
            },
            // Catch-all
            {
                path: "/page-not-found",
                element: <PageNotFound/>
            },
            {
                path: "*",
                element: <PageNotFound/>
            }
        ]
    }
]);
